const validateForHelloSign = (value) => {
  const forbiddenPattern = /\[\$/;
  if (forbiddenPattern.test(value)) {
    return '[$ is not an allowed combination of characters';
  }
  return undefined;
};

export default validateForHelloSign;
